/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import Select from "react-select";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxChargeRate from "../../../util/remote/ajaxChargeRate";
import AdminContext from "../../../Context/AdminContext";

function AddSetting(props) {
  const [vendor, setVendor] = useState("");
  const [functionName, setFunctionName] = useState("");
  const [school, setSchool] = useState("");
  const [category, setCategory] = useState("");
  const {schoolList} = useContext(SchoolContext);
  const [loading2, setLoading2] = useState(false);
  const {vendorList, getVendorList} = useContext(AdminContext);

  useEffect(() => {
    getVendorList();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
      if (functionName.length > 0) {
        setLoading2(true)
        const server_response = await ajaxChargeRate.createSetting(functionName, vendor, school);
        setLoading2(false)
        if (server_response.status === "OK") {
          toast.success(server_response.message);
          props.g();
          props.h();
          props.i();
          resetForm();
        } else {
          toast.error(server_response.message);
        }
      } else {
        toast.error("Please select a transaction type!");
      }
    
  };

  const resetForm = () => {
    setFunctionName("");
    setCategory("");
    setVendor("");
    setSchool("");
  };

  return (
    <div className="card height-auto">
      <div className="card-body">
        <div className="heading-layout1">
          <div className="item-title">
            <h5 style={{marginBottom:0}}>Add Pocket Money Setting</h5>
          </div>
        </div>
        <form
          onSubmit={(e) => handleAdd(e)}
          method="post"
          class="new-added-form">
          <div className="row">
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Setting Category <span style={{color:"red"}}>*</span> </label>
              <select className="col-12 form-control" value={category} style={{border: "1px solid grey"}} onChange={(e) => setCategory(e.target.value)}>
                <option value={true}>Select...</option>
                <option value="Global">Global Setting</option>
                <option value="School">School Setting</option>
                <option value="Vendor">Vendor Setting</option>

              </select>
            </div>
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Transaction Type <span style={{color:"red"}}>*</span> </label>
               <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={functionName}
                    onChange={(e) => setFunctionName(e.target.value)}>
                    <option value="" selected disabled>Select transaction type...</option>
                    <option value="Student Deposits">Student Deposits</option>
                    <option value="Card Purchases">Purchases (Card / Wristband)</option>
                    <option value="Face Purchases">Purchases (Face)</option>
                    <option value="Fingerprint Purchases">Purchases (Fingerprint)</option>
                    <option value="Cashouts">Student Withdrawals / Cashouts (PIN)</option>
                    <option value="Face Cashouts">Student Withdrawals / Cashouts (Face)</option>
                    <option value="Fingerprint Cashouts">Student Withdrawals / Cashouts (Fingerprint)</option>
                    <option value="Vendor Disbursements">Vendor Disbursements</option>
                    <option value="Buzztime Load">Buzztime Load</option>
                    <option value="Activations">Card / Wristband Activations</option>
                    <option value="Replacements">Card / Wristband Replacements</option>
                    <option value="Fingerprint Enrollments">Fingerprint Enrollments</option>
                    <option value="Termly Fees">Termly Fees</option>


                </select>
            </div>
            {category === "School"? <div className="col-lg-12 col-12 form-group">
                <label htmlFor="">School <span style={{color:"red"}}>*</span></label>
                <Select
                  onChange={(e) => setSchool(e.school_id)}
                  getOptionLabel={(option) => option.school_name}
                  getOptionValue={(option) => option.school_id}
                  isSearchable
                  options={Array.isArray(schoolList) ? schoolList : []}
                  value={
                      Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                  }
                />
            </div> :
            
            category === "Vendor" ?
            <div className="col-lg-12 col-12 form-group">
                <label htmlFor="">Vendor <span style={{color:"red"}}>*</span></label>
                <Select
                  onChange={(e) => setVendor(e.user_id)}
                  getOptionLabel={(option) => option.full_name}
                  getOptionValue={(option) => option.user_id}
                  isSearchable
                  required
                  options={Array.isArray(vendorList) ? vendorList : []}
                  value={
                      Array.isArray(vendorList) &&
                      vendorList.find((value) => value.user_id === vendor)
                  }
                />
            </div>:""}
            
          </div>
          <div className="mt-5">
          {loading2 && (<button type="submit" className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue" disabled><i class="fa fa-spinner fa-spin mr-2"></i>Disabling...</button>)}
            {!loading2 && <button
              type="submit"
              className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue">
              Disable Transaction
            </button>}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSetting
